// Custom Button

import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonComponent = styled(Button)(() => ({
    backgroundColor: '#333', 
    color: '#fff', 
    padding: '10px 20px',
    '&:hover': {
        backgroundColor: '#333',
    },
}));

const CustomButton = (props) => {
  return <ButtonComponent onClick={props.onClick}>{props.text}</ButtonComponent>;
};

export default CustomButton;
